import React from "react";
import styles from "../../asset/About/Leadership.module.scss";
import Imgage1 from "../../asset/homefour/aboutimageclient.webp"

const LeadershipAbout = () => {
  return (
    <section className={styles.leadershipSection}>
      <div className={styles.container}>
        <h2 className={styles.title}>Leadership Team</h2>
        <p className={styles.intro}>
          The founders and directors of Sai Digitizing — Jackson, Loganathan Nataraj, and Karthik — form an experienced leadership team, bringing both specialized expertise and unique strengths to the table.
        </p>

        <div className={styles.members}>
          <div className={styles.member}>
            <h3>Jackson</h3>
            <h4>Managing Director</h4>
            <p>
              A natural entrepreneur, Jackson combines a strong outsourcing industry background with proven technology and management expertise gained through over two decades of hands-on experience. The entrepreneurial phase of his professional career began with SAI Digitizing, which delivers high-quality digitizing and IT-enabled services to global clients through two delivery centers in the United States of America. Jackson oversees the overall management of the company, including business planning, finance, personnel, and administrative operations.
            </p>
            <p>
              Prior to founding SAI Digitizing, Jackson worked as Systems Division In-Charge for seven years at a multinational organization, where he was responsible for data analysis and operational oversight.



            </p>
            <p>
              Jackson holds a Master of Business Administration (MBA) from California State University, USA.
            </p>
          </div>

          <div className={styles.member}>
            <h3>Loganathan Natarajan</h3>
            <h4>Director</h4>
            <p>
              A technology specialist, Loganathan leverages strong expertise in hardware, software, and IT-enabled services (ITES), developed over two decades of experience, to drive business strategy as well as key systems and processes. An early entrant in the ITES domain, he established Ozone Technologies, a data processing company that worked with market leaders such as IMRB and later expanded into providing Litigation Support Services.
            </p>
            <p>
              Loganathan is responsible for overseeing the company’s IT operations and infrastructure, ensuring robust systems, scalability, and operational efficiency.            </p>
            <p>
              Previously, Loganathan worked as an IT Consultant, delivering networking and infrastructure solutions for corporate projects. He later served as Business Development Manager for an organization providing ERP solutions for the SME sector.            </p>



            <p>



              Loganathan holds a Bachelor’s Degree in Business Administration from Madras University, Chennai, India
            </p>
          </div>

          <div className={styles.member}>
            <h3>Karthik.K</h3>
            <h4>Director</h4>
            <p>
              A designer by education and experience, Karthik brings a highly creative mindset shaped by work at leading ITES companies and advertising agencies, along with a strong business acumen developed over more than two decades in leadership roles. He has over 20 years of experience in the ITES and outsourcing space in customer-facing roles, specifically serving the promotional products and apparel decoration sectors in the United States, delivering a wide range of design solutions
            </p>
            <p>
              Karthik oversees the company’s operations across artwork and digitizing services. He is responsible for building and nurturing long-term client relationships, expanding the scope of design services to meet evolving customer needs, and mentoring teams to ensure consistent design excellence and service quality.            </p>
            <p>
              Previously, Karthik headed and directed operations at a leading artwork and digitizing services company that was also a pioneer in the industry. Prior to this role, he worked as an independent business owner as the founder and designer of Motif – The Design Place.            </p>

            <p>Karthik is a graduate of the Government College of Fine Arts, Chennai, India.</p>
          </div>
          <div className={styles.bottomSection}>
            <img
              src={Imgage1}
              alt="Leadership Team"
              className={styles.teamImage}
            />
            <div className={styles.missionVision}>
              <div>
                <h3>MISSION</h3>
                <p>
                  COMMITMENT TO EXCELLENT QUALITY, RAPID TURNAROUND AND IMPACTFUL CUSTOMER SERVICE IN A COLLABORATIVE ENVIRONMENT
                </p>
              </div>
              <div>
                <h3>VISION</h3>
                <p>
                  EMERGE AS THE NEW BENCHMARK FOR EXCELLENCE IN THE DIGITAL ART AND DESIGN SPACE
                </p>
              </div>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
};

export default LeadershipAbout;
